import React, { Component } from 'react';
import * as MobileInventoryManagementAction from '../actions/MobileInventoryManagementAction';
import MobileInventoryManagementStore from '../stores/MobileInventoryManagementStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'


import * as MenuAction from '../actions/MenuAction'

import * as XLSX from "xlsx";

import swal from 'sweetalert';
import { textAlign } from '@material-ui/system';

let currentPagePath;
let isSubmit = false;
let canInsert = true;
let showPopUp = true//PC_WW_1055_01, Divis Kumar R K


class MobileInventoryManagementComponent extends Component {

    constructor(props) {

        super(props);
        this.OnHandleExisChange = this.OnHandleExisChange.bind(this);
        this.showReasonPopUp = this.showReasonPopUp.bind(this);
        this.SaveItemClick = this.SaveItemClick.bind(this);
        this.dropDownhandlechange = this.dropDownhandlechange.bind(this);
        this.bindReasons = this.bindReasons.bind(this);
        this.Bindforcast = this.Bindforcast.bind(this);
        this.expandAll = this.expandAll.bind(this);
        // this.exportToExcel = this.exportToExcel.bind(this);
        this.GetDataClick = this.GetDataClick.bind(this);
        this.hidePopUp = this.hidePopUp.bind(this);
        this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        this.OnHandleExisChange = this.OnHandleExisChange.bind(this);
        this.PageLoad = this.PageLoad.bind(this);
        this.PageLoadResponse = this.PageLoadResponse.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.handleFavorite = this.handleFavorite.bind(this);
        this.updateFavPageResponse = this.updateFavPageResponse.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.expandAll = this.expandAll.bind(this);
        this.onAccordianClick = this.onAccordianClick.bind(this);
        this.BindDataGrid = this.BindDataGrid.bind(this);
        this.ExcelButtonClick = this.ExcelButtonClick.bind(this);

        this.PageOrSortClick = this.PageOrSortClick.bind(this);
        this.PageOrSortDataResponse = this.PageOrSortDataResponse.bind(this);



        const { valueStrings } = props;

        this.state = {


            pageCount: "",
            pageNo: "1",
            PageLoadResponse: [],
            ImageAr: [],
            SubRegionDD: [],
            RegionDD: [],
            TechNameDD: [],
            TruckIdDD: [],
            GridData: [],
            ExpandALL: false,
            ForecastData: [],
            SelectedRegion: "",
            SelectedSubRegion: "",
            SelectedReplenedClass: "",
            SelectedThreshold: "",
            SelectedTruckId: "",
            SelectedItemReplenStatus: "",
            selectedOption: "",
            SelectedTechName: "",
            reasonError: true,
            customE: null,
            customVal: null,
            customIndex: null,
            Reasons: [],
            oldValues: [],
            totalRecords: "",
            sort: "",
            ItemIDData: [], //PC_CPW_241_01
            SelectedItemID: ""
        }
    }
    componentDidMount() {

        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        this.PageLoad();
        MobileInventoryManagementStore.on('PageLoad', this.PageLoadResponse);
        MobileInventoryManagementStore.on('GridDataBind', this.GetDataResponse);
        MobileInventoryManagementStore.on('SaveItem', this.UpdateItemResponse);
        MobileInventoryManagementStore.on('ProcessReplen', this.ProcessReplenResponse);
        MobileInventoryManagementStore.on('ApproveALL', this.ApproveALLResponse);
        MobileInventoryManagementStore.on('OnStatusChange', this.OnStatusChangeResponse);
        //  MobileInventoryManagementStore.on('OnStatusChange', this.OnStatusChangeResponse);       
        MobileInventoryManagementStore.on('MobileInventory_CurrentFavPage', this.loadFavPageResponse.bind(this));
        MobileInventoryManagementStore.on("MobileInventory_InsertFavPage", this.updateFavPageResponse.bind(this));
        MobileInventoryManagementStore.on("excelClick", this.ExportToExcelClickResponse.bind(this));
        MobileInventoryManagementStore.on('DataBind', this.PageOrSortDataResponse);

        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        MobileInventoryManagementAction.getCurrentFavPage(getFavPageBO);


    }
    componentWillUnmount() {
        MobileInventoryManagementStore.removeListener('PageLoad', this.PageLoadResponse);
        MobileInventoryManagementStore.removeListener('GridDataBind', this.GetDataResponse);
        MobileInventoryManagementStore.removeListener('SaveItem', this.UpdateItemResponse);
        MobileInventoryManagementStore.removeListener('ApproveALL', this.ApproveALLResponse);
        MobileInventoryManagementStore.removeListener('OnStatusChange', this.OnStatusChangeResponse);
        // MobileInventoryManagementStore.removeListener("ProcessReplen", this.printSelectedItemResonse);
        MobileInventoryManagementStore.removeListener("MobileInventory_CurrentFavPage", this.loadFavPageResponse.bind(this));
        MobileInventoryManagementStore.removeListener("MobileInventory_InsertFavPage", this.updateFavPageResponse.bind(this));
        MobileInventoryManagementStore.removeListener("excelClick", this.ExportToExcelClickResponse.bind(this));
        MobileInventoryManagementStore.removeListener('DataBind', this.PageOrSortDataResponse);

    }

    PageLoad = () => {


        let PageLoadBO = {
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),

        };
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        MobileInventoryManagementAction.PageLoad(PageLoadBO);

    }

    PageLoadResponse = () => {
        //debugger
        let PageLoadResponse = JSON.parse(MobileInventoryManagementStore.PageLoadData);
        let Dropdowns = PageLoadResponse.Table;
        let ItemIDData = PageLoadResponse.ItemIDData; //PC_CPW_241_02
        let ItemIDDataDD = []
        let RegionDD = [];
        let TechNamedd = [];
        if (Dropdowns == undefined) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in retriving the data"
            });
        }
        else {
            let TechNameDD = Dropdowns.filter((v, i, a) => a.findIndex(t => (t.ISA_EMPLOYEE_ID === v.ISA_EMPLOYEE_ID)) === i)
            TechNameDD = TechNameDD.sort(function (a, b) {
                if (a.ISA_EMPLOYEE_NAME > b.ISA_EMPLOYEE_NAME) {
                    return 1;
                }
                if (b.ISA_EMPLOYEE_NAME > a.ISA_EMPLOYEE_NAME) {
                    return -1;
                }
                return 0;
            });
            TechNameDD.map((item, index) => {

                let TechName = item.ISA_EMPLOYEE_NAME;
                TechName = TechName.replace(',', ', ');


                if (index == 0) {
                    let defaultvalue = {
                        value: "",
                        label: "Select All"
                    }
                    TechNamedd.push(defaultvalue)
                }
                let obj = {
                    value: item.ISA_EMPLOYEE_ID,
                    label: TechName
                };
                TechNamedd.push(obj)


            });



            let DuplicateRegion = Dropdowns.filter((v, i, a) => a.findIndex(t => (t.ISA_REGION === v.ISA_REGION)) === i)
            DuplicateRegion.map((item, index) => {

                let obj = {
                    value: item.ISA_REGION,
                    label: item.ISA_REGION
                };
                RegionDD.push(obj)


            });

        }
        //PC_CPW_241_02
        ItemIDData.map((item, index) => {

            if (index == 0) {
                let defaultvalue = {
                    value: "",
                    label: "Select All"
                }
                ItemIDDataDD.push(defaultvalue)
            }
            let obj = {
                value: item.INV_ITEM_ID,
                label: item.INV_ITEM_ID
            };
            ItemIDDataDD.push(obj)


        });

        this.setState({ RegionDD: RegionDD, TechNameDD: TechNamedd, PageLoadResponse: Dropdowns, ItemIDData: ItemIDDataDD })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    dropDownhandlechange = (event, type) => {
        let area = ""

        switch (type) {
            case "Region": {
                $("#TechNameDD").removeClass("disabledbutton");
                let subRegionDD = [];
                let TechidDD = [];
                let selectall = []
                let pageload = this.state.PageLoadResponse
                let RegionSelected = event.target.value
                console.error("pageload", this.state.PageLoadResponse)
                if (RegionSelected == "") {
                    let TechNameDD = pageload.filter((v, i, a) => a.findIndex(t => (t.ISA_EMPLOYEE_ID === v.ISA_EMPLOYEE_ID)) === i)
                    TechNameDD = TechNameDD.sort(function (a, b) {
                        if (a.ISA_EMPLOYEE_NAME > b.ISA_EMPLOYEE_NAME) {
                            return 1;
                        }
                        if (b.ISA_EMPLOYEE_NAME > a.ISA_EMPLOYEE_NAME) {
                            return -1;
                        }
                        return 0;
                    });
                    TechNameDD.map((item, index) => {
                        let TechName = item.ISA_EMPLOYEE_NAME;
                        TechName = TechName.replace(',', ', ');
                        let obj = {
                            value: item.ISA_EMPLOYEE_ID,
                            label: TechName
                        };

                        TechidDD.push(obj)


                    });
                    this.setState({
                        SelectedRegion: RegionSelected, TechNameDD: TechidDD, SubRegionDD: [], SelectedTechName: "",
                        TruckIdDD: [],
                        SelectedTruckId: "",
                        SelectedSubRegion: "", GridData: []
                    })
                }
                else {

                    pageload.map((item, index) => {


                        if (item.ISA_REGION == event.target.value && subRegionDD.indexOf(item.ISA_SUB_REGION) == -1) {

                            let obj = {
                                value: item.ISA_SUB_REGION,
                                label: item.ISA_SUB_REGION
                            }
                            subRegionDD.push(obj);
                        }
                        if (item.ISA_REGION == event.target.value && TechidDD.indexOf(item.ISA_EMPLOYEE_ID) == -1) {

                            let TechName = item.ISA_EMPLOYEE_NAME;
                            TechName = TechName.replace(',', ', ');

                            let obj = {
                                value: item.ISA_EMPLOYEE_ID,
                                label: TechName
                            };
                            TechidDD.push(obj);
                        }
                    })
                    TechidDD = TechidDD.sort(function (a, b) {
                        if (a.label > b.label) {
                            return 1;
                        }
                        if (b.label > a.label) {
                            return -1;
                        }
                        return 0;
                    });

                    let defaultvalue = {
                        value: "",
                        label: "Select All"
                    }
                    selectall.push(defaultvalue)


                    TechidDD = [...selectall, ...TechidDD]
                    let Techiddd = TechidDD.filter((ele, ind) => ind === TechidDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                    let dd = subRegionDD.filter((ele, ind) => ind === subRegionDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                    this.setState({
                        SelectedRegion: RegionSelected, SubRegionDD: dd, TechNameDD: Techiddd, SelectedTechName: "",
                        TruckIdDD: [],
                        SelectedTruckId: "",
                        SelectedSubRegion: "", GridData: []



                    })
                }
                break;
            }
            case "SubRegion": {
                $("#TechNameDD").removeClass("disabledbutton");
                let TruckidDD = [];
                let TechidDD = [];
                let selectall = [];
                let SubRegionSelected = event.target.value


                if (SubRegionSelected == "") {
                    this.state.PageLoadResponse.map((item, index) => {

                        if (item.ISA_SUB_REGION == event.target.value && TruckidDD.indexOf(item.ISA_TRUCK_ID) == -1) {
                            let obj = {
                                value: item.ISA_TRUCK_ID,
                                label: item.ISA_TRUCK_ID
                            }
                            TruckidDD.push(obj);
                        }
                        if (this.state.SelectedRegion != "") {
                            if (item.ISA_REGION == this.state.SelectedRegion && TechidDD.indexOf(item.ISA_EMPLOYEE_ID) == -1) {
                                let TechName = item.ISA_EMPLOYEE_NAME;
                                TechName = TechName.replace(',', ', ');

                                let obj = {
                                    value: item.ISA_EMPLOYEE_ID,
                                    label: TechName
                                };
                                TechidDD.push(obj);
                            }
                        }
                        else {
                            let TechName = item.ISA_EMPLOYEE_NAME;
                            TechName = TechName.replace(',', ', ');

                            let obj = {
                                value: item.ISA_EMPLOYEE_ID,
                                label: TechName
                            };
                            TechidDD.push(obj);

                        }
                    })

                }
                else {
                    this.state.PageLoadResponse.map((item, index) => {

                        if (item.ISA_SUB_REGION == event.target.value && TruckidDD.indexOf(item.ISA_TRUCK_ID) == -1) {
                            let obj = {
                                value: item.ISA_TRUCK_ID,
                                label: item.ISA_TRUCK_ID
                            }
                            TruckidDD.push(obj);
                        }

                        if (item.ISA_SUB_REGION == event.target.value && TechidDD.indexOf(item.ISA_EMPLOYEE_ID) == -1) {
                            let TechName = item.ISA_EMPLOYEE_NAME;
                            TechName = TechName.replace(',', ', ');

                            let obj = {
                                value: item.ISA_EMPLOYEE_ID,
                                label: TechName
                            };
                            TechidDD.push(obj);
                        }
                    })



                }
                TechidDD = TechidDD.sort(function (a, b) {
                    if (a.label > b.label) {
                        return 1;
                    }
                    if (b.label > a.label) {
                        return -1;
                    }
                    return 0;
                });
                let defaultvalue = {
                    value: "",
                    label: "Select All"
                }
                selectall.push(defaultvalue)


                TechidDD = [...selectall, ...TechidDD]
                let Techiddd = TechidDD.filter((ele, ind) => ind === TechidDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                let dd = TruckidDD.filter((ele, ind) => ind === TruckidDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                this.setState({
                    SelectedTruckId: "",
                    TruckIdDD: dd, SelectedSubRegion: SubRegionSelected, SelectedTruckId: "", SelectedTechName: "", GridData: [], TechNameDD: Techiddd
                })
                break;
            }

            case "TruckID": {
                let TechidDD = [];
                let selectall = []

                let TruckIDSelected = event.target.value
                if (TruckIDSelected != "") {
                    $("#TechNameDD").addClass("disabledbutton");

                    this.state.PageLoadResponse.map((item, index) => {

                        if (item.ISA_TRUCK_ID == event.target.value && TechidDD.indexOf(item.ISA_EMPLOYEE_ID) == -1) {
                            let TechName = item.ISA_EMPLOYEE_NAME;
                            TechName = TechName.replace(',', ', ');

                            let obj = {
                                value: item.ISA_EMPLOYEE_ID,
                                label: TechName
                            };
                            TechidDD.push(obj);
                        }
                    })

                    TechidDD = [...selectall, ...TechidDD]
                    let dd = TechidDD.filter((ele, ind) => ind === TechidDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                    this.setState({ SelectedTruckId: TruckIDSelected, SelectedTechName: dd, GridData: [] })
                }
                else {
                    $("#TechNameDD").removeClass("disabledbutton");
                    this.setState({ SelectedTruckId: TruckIDSelected, SelectedTechName: "", GridData: [] })
                }


                break;
            }
            case "TechName": {

                let TechNameSelected = event


                this.setState({ SelectedTechName: TechNameSelected, GridData: [] })
                break;
            }
            case "Threshold": {

                this.setState({ SelectedThreshold: event.target.value, GridData: [] });
                break;
            }
            case "ReplenishStatus": {
                this.setState({ SelectedReplenedClass: event.target.value, GridData: [] });
                break;
            }
            //PC_CPW_241_03
            case "ItemID": {

                // let TechNameSelected = event

                this.setState({ SelectedItemID: event, GridData: [] })
                break;
            }

        }
    }
    //OnStatusChangeResponse = () => {
    //    //debugger
    //    $(`#${SDIConstants.SDILoader}`).addClass('hide');
    //    let response = JSON.parse(MobileInventoryManagementStore.OnStatusChange);

    //}

    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.PageOrSortClick(pageNo, this.state.sort)
        this.setState({ pageNo: pageNo, isExpand: false });
    }

    PageOrSortClick = (pageNo, sort) => {
        let BO = {

            Region: this.state.SelectedRegion,
            SubRegion: this.state.SelectedSubRegion,
            TruckID: this.state.SelectedTruckId,
            ThresHold: this.state.SelectedThreshold,
            ReplenishStatus: this.state.SelectedReplenedClass,
            TechName: this.state.SelectedTechName.value,
            IsGridDataLoad: true,
            IsApproveAll: false,
            EmployeeID: CookieService.getLocalStorageValues("Session_SDIEMP"),
            sortBy: sort,
            CurrentPage: pageNo,
            NeededCount: "10",
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            ItemID: this.state.SelectedItemID.value //PC_CPW_241_04
        }
        this.setState({ pageNo: pageNo, isExpand: false, sort: sort })
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        MobileInventoryManagementAction.DataBind(BO)
    }

    handleFavorite = (event) => {
        //debugger
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Mobile Inventory Management System",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            MobileInventoryManagementAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            MobileInventoryManagementAction.deleteFavPage(deleteFavPageBO)
        }
    };
    loadFavPageResponse = () => {
        //debugger
        let favPageResponse = JSON.parse(MobileInventoryManagementStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        //debugger
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (MobileInventoryManagementStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(MobileInventoryManagementStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(MobileInventoryManagementStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    expandAll = () => {
        if (this.state.isExpand == false) {
            this.setState({ isExpand: true });
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');
            $('.header-arrow').addClass('accordion-arrow-change');
            $('.content-row').removeClass('d-none');
        } else {
            this.setState({ isExpand: false });
            $('.header-arrow').addClass('accordion-arrow-change');
            $('.content-row').removeClass('d-none');
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');

        }
    }
    onAccordianClick = (event, index) => {
        //Bug 5360 - Nandhini L
        // Toggle the clicked accordion
        var contentRow = $(`#contentrow-${index}`);

        if (contentRow.hasClass('d-none')) {
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');
            $('tr').removeClass('tr-border');
            $(event.currentTarget).children().addClass('accordion-arrow-change');
            contentRow.removeClass('d-none');
            $(event.currentTarget).parent('tr').addClass('tr-border');
        } else {
            $(event.currentTarget).children().removeClass('accordion-arrow-change');
            contentRow.addClass('d-none');
            $(event.currentTarget).parent('tr').removeClass('tr-border');
        }
    };

    sort = (Arr, indexval, nextindexval, Type) => {
        let temp = []
        let size = Arr.length
        let i, j = 0;

        if (Type == "ASC") {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    if (eval(indexval) > eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        } else {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    if (eval(indexval) < eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        }
    }

    SortClick = (event, sortBy, columnName) => {
        //debugger;
        //let MatGrid = this.state.GridData;
        //let data = [];
        //console.log("MatGrid", MatGrid)
        if (sortBy == "ASC") {
            switch (columnName) {
                case "ItemID":
                    //data = this.sort(MatGrid, "Arr[i].INV_ITEM_ID", "Arr[j].INV_ITEM_ID", "ASC")
                    this.PageOrSortClick(this.state.pageNo, sortBy)
                    break;
            }
        }

        else {
            switch (columnName) {
                case "ItemID": {
                    //data = this.sort(MatGrid, "Arr[i].INV_ITEM_ID", "Arr[j].INV_ITEM_ID", "DESC")
                    this.PageOrSortClick(this.state.pageNo, sortBy)
                    break;
                }
            }
        };
        this.setState({ sort: sortBy });
    }

    OnStatusChange = (event, val, index) => {
        let GridData = [...this.state.GridData];
        this.state.GridData[index].REPLEN_STATUS = event.target.value;


        this.setState({ GridData });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let BO = {
            ddlSite: this.state.SelectSite,
            User_ID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            BusinessUnit: val.BUSINESS_UNIT,
            TruckID: val.ISA_TRUCK_ID,
            ItemID: val.INV_ITEM_ID,
            Replen_Status: event.target.value,
            TruckID: val.ISA_TRUCK_ID,
            Replenish_ID: val.REPLENISH_ID,
            Quantity: val.EditQuantity
        }

        MobileInventoryManagementAction.OnStatusChangeAction(BO)

    }

    //OnStatusChangeResponse = () => {
    //    let Response = JSON.parse(MobileInventoryManagementStore.OnStatusChange);
    //    this.GetDataClick() //PC_WW_1055_01, Divis Kumar R K
    //}

    SaveItemClick = (e, val, index) => {
        this.setState({ customE: e, customVal: val, customIndex: index })
        let Min = val.EditMinValue;
        let Max = val.EditMaxValue;
        let Quantity = val.EditQuantity;
        if (Min == "" && Quantity == "" && Max == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Quantity, min and max cannot be empty"
            });
            return;
        }
        else if (Min == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Min cannot be empty"
            });
            return;
        }
        else if (Max == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Max cannot be empty"
            });
            return;
        }

        else if (Quantity == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Quantity cannot be empty"
            });
            return;
        }

        else if (parseInt(Min) > parseInt(Max)) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Minimum value should not be greater than maximum value"
            });
        } else {
            if (this.state.oldValues[index].REPLENISH_CLASS != val.EditReplenClass && isSubmit == false && val.EditReplenClass == "X") {
                this.showReasonPopUp();
            }
            if (canInsert == true) {
                //debugger;
                let BO = {
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    User_ID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                    OldQunatity: val.reorder_qty,
                    OldMinValue: val.reorder_point,
                    OldMaxValue: val.QTY_MAXIMUM,
                    OldReplenClass: val.replen_class,
                    Qunatity: val.EditQuantity,
                    MinValue: val.EditMinValue,
                    BusinessUnit: val.BUSINESS_UNIT,
                    MaxValue: val.EditMaxValue,
                    ReplenClass: val.EditReplenClass,
                    TruckID: val.ISA_TRUCK_ID,
                    ItemID: val.INV_ITEM_ID,
                    Replenish_ID: val.REPLENISH_ID,
                    ReplenOffReason: this.state.selectedOption/*WW-798, changed and added values in BO, Divis Kumar R K*/
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                MobileInventoryManagementAction.saveItem(BO);
                isSubmit = false;
                this.setState({ selectedOption: "" })
            }
        }
    }

    UpdateItemResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let GetDataResponse = JSON.parse(MobileInventoryManagementStore.SaveItem);


        swal({
            allowOutsideClick: false,
            closeOnClickOutside: false,
            text: GetDataResponse.FlagTable[0].lblDBErr1
        });

        this.PageOrSortClick('1', this.state.sort)

        //this.GetDataClick()
    }
    GetDataClick = () => {
        //debugger

        let BO = {

            Region: this.state.SelectedRegion,
            SubRegion: this.state.SelectedSubRegion,
            TruckID: this.state.SelectedTruckId,
            ThresHold: this.state.SelectedThreshold,
            ReplenishStatus: this.state.SelectedReplenedClass,
            TechName: this.state.SelectedTechName.value,
            IsGridDataLoad: true,
            IsApproveAll: false,
            EmployeeID: CookieService.getLocalStorageValues("Session_SDIEMP"),
            sortBy: "",
            CurrentPage: "1",
            NeededCount: "10",
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            ItemID: this.state.SelectedItemID.value //PC_CPW_241_04
        }
        this.setState({ pageNo: "1", isExpand: false })
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        MobileInventoryManagementAction.GridDataBind(BO)
    }

    BindRegion = () => {
        if (this.state.RegionDD.length > 0) {
            return this.state.RegionDD.map((value, ID) => {
                return (
                    <option key={value.value} value={value.value}>{value.label}</option>
                )

            });
        }

    }
    BindSubRegion = () => {

        return this.state.SubRegionDD.map((value, ID) => {
            return (
                <option key={value.value} value={value.value}>{value.label}</option>
            )

        });
    }
    BindTruckid = () => {
        return this.state.TruckIdDD.map((value, ID) => {
            return (
                <option key={value.value} value={value.value}>{value.label}</option>
            )

        });
    }
    BindTechName = () => {
        return this.state.TechNameDD.map((value, ID) => {
            return (
                <option key={value.value} value={value.value}>{value.label}</option>
            )

        });
    }


    PageOrSortDataResponse = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let GetDataResponse = JSON.parse(MobileInventoryManagementStore.GridLoadData);
        let data = GetDataResponse.GridData;
        let ImageTable = GetDataResponse.ImgTable;
        let ForecastData = GetDataResponse.ForecastData;
        let ReasonTable = GetDataResponse.ReasonTable;
        let totalCount = GetDataResponse.totalCount[0].TOTALCOUNT;
        $('.header-arrow').addClass('accordion-arrow-change');
        $('.content-row').removeClass('d-none');
        $('.header-arrow').removeClass('accordion-arrow-change');
        $('.content-row').addClass('d-none');

        if (data != undefined && data != null && data.length != 0) {

            data.forEach((value, index) => {
                let ProcessDate = value.PROCESS_DATE;
                if (ProcessDate != null && ProcessDate != undefined && ProcessDate != "") {
                    ProcessDate = ProcessDate.split('T')[0];
                }
                let LastDate = value.LAST_ISSUE;
                if (LastDate != null && LastDate != undefined && LastDate != "") {
                    LastDate = LastDate.split('T')[0];
                }
                value.EditMinValue = value.REORDER_POINT;
                value.EditMaxValue = value.QTY_MAXIMUM;
                value.EditQuantity = value.REORDER_QTY;
                value.EditReplenClass = value.REPLENISH_CLASS;
                value.EditPROCESS_DATE = ProcessDate;
                value.EditLAST_ISSUE = LastDate;

            });
        }

        this.setState({ GridData: data, sort: this.state.sort, pageNo: this.state.pageNo, ForecastData: ForecastData, isExpand: false, pageCount: totalCount / 10, totalRecords: totalCount, ImageAr: ImageTable, Reasons: ReasonTable, oldValues: data });
    }


    GetDataResponse = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let GetDataResponse = JSON.parse(MobileInventoryManagementStore.GridLoadData);
        let data = GetDataResponse.GridData;
        let ImageTable = GetDataResponse.ImgTable;
        let ForecastData = GetDataResponse.ForecastData;
        let ReasonTable = GetDataResponse.ReasonTable;
        let totalCount = GetDataResponse.totalCount[0].TOTALCOUNT;
        $('.header-arrow').addClass('accordion-arrow-change');
        $('.content-row').removeClass('d-none');
        $('.header-arrow').removeClass('accordion-arrow-change');
        $('.content-row').addClass('d-none');

        if (data != undefined && data != null && data.length != 0) {

            data.forEach((value, index) => {
                let ProcessDate = value.PROCESS_DATE;
                if (ProcessDate != null && ProcessDate != undefined && ProcessDate != "") {
                    ProcessDate = ProcessDate.split('T')[0];
                }
                let LastDate = value.LAST_ISSUE;
                if (LastDate != null && LastDate != undefined && LastDate != "") {
                    LastDate = LastDate.split('T')[0];
                }


                value.EditMinValue = value.REORDER_POINT;
                value.EditMaxValue = value.QTY_MAXIMUM;
                value.EditQuantity = value.REORDER_QTY;
                value.EditReplenClass = value.REPLENISH_CLASS;
                value.EditPROCESS_DATE = ProcessDate;
                value.EditLAST_ISSUE = LastDate;


            });
        }

        this.setState({ GridData: data, pageNo: "1", ForecastData: ForecastData, isExpand: false, pageCount: totalCount / 10, totalRecords: totalCount, ImageAr: ImageTable, Reasons: ReasonTable, oldValues: data });

        if (data != undefined) {
            if (data.length == 0 && showPopUp) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No record found"
                });

                return;
            }
        }

    }

    cancelClick = (type, index) => {
        if (type == "pageload") {
            $("#TechNameDD").removeClass("disabledbutton");
            let pageload = this.state.PageLoadResponse;
            let TechidDD = []


            const uniqueTechs = new Map();

            pageload.forEach(item => {
                // Use Map to ensure uniqueness based on ISA_EMPLOYEE_ID
                if (!uniqueTechs.has(item.ISA_EMPLOYEE_ID)) {
                    uniqueTechs.set(item.ISA_EMPLOYEE_ID, item.ISA_EMPLOYEE_NAME);
                }
            });

            // Convert the Map to an array and sort it
            const TechName = Array.from(uniqueTechs.entries())
                .sort((a, b) => a[1].localeCompare(b[1])) // Sort by ISA_EMPLOYEE_NAME using localeCompare for better string comparison
                .map((entry, index) => {
                    const [id, name] = entry;
                    return {
                        value: id,
                        label: name.replace(',', ', '),
                    };
                });

            // Add the default "Select All" option at the beginning
            TechidDD = [{ value: "", label: "Select All" }, ...TechName];
            //PC_CPW_241_06
            this.setState({ SubRegionDD: [], GridData: [], pageNo: "1", SelectedTechName: "", SelectedItemID: "", TechNameDD: TechidDD, TruckIdDD: [], isExpand: false, SelectedRegion: "", SelectedSubRegion: "", SelectedThreshold: "", SelectedTruckId: "", SelectedReplenedClass: "" });
            return;
        }

        else if (type == "grid") {
            let { GridData } = this.state;


            this.state.GridData[index].EditMinValue = this.state.GridData[index].REORDER_POINT;
            this.state.GridData[index].EditMaxValue = this.state.GridData[index].QTY_MAXIMUM;
            this.state.GridData[index].EditQuantity = this.state.GridData[index].REORDER_QTY;
            this.state.GridData[index].EditReplenClass = this.state.GridData[index].REPLENISH_CLASS;
            this.state.GridData[index].Replen_Status = this.state.GridData[index].REPLEN_STATUS;





            this.setState({ GridData: GridData })
        }
    }

    showReasonPopUp = () => { /*WW-798, used to display pop up, Divis Kumar R K*/
        canInsert = false;
        $('#reasonPopUp').modal('show');
    }

    insertReason = () => { /*WW-798, this block gets the reason, Divis Kumar R K*/
        if (this.state.selectedOption == "") {
            this.setState({ reasonError: false })
        }
        else {
            $('#reasonPopUp').modal('hide');
            isSubmit = true;
            canInsert = true;
            this.SaveItemClick(this.state.customE, this.state.customVal, this.state.customIndex);
            this.setState({ reasonError: true })
        }
    }

    hidePopUp = () => { /*WW-798, hides pop up, Divis Kumar R K*/
        $('#reasonPopUp').modal('hide');
        canInsert = true;
        this.setState({ selectedOption: "", reasonError: true })
    }


    onChangeReasonPopup = (e) => {
        this.setState({ selectedOption: e.target.value })
        if (e.target.value != "") {

            this.setState({ reasonError: true })
        }
    }

    bindReasons = () => {/*WW-798, bind reason in pop up, Divis Kumar R K*/

        return this.state.Reasons.map((reason, index) => {
            return (<option value={reason.DESCR50}>{reason.DESCR50}</option>)
        });
    }

    Bindforcast = (month) => {
        return month.map((val, Index) => {
            return (

                <tr>
                    <td>{val.MONTH}</td>
                    <td className="text-right">{val.QTY_PICKEDVAL}</td>
                </tr>

            );
        })
    }
    // Regression bug -5519 - K. Surya - Walmart_ Mobile Inventory Management System_Able to enter the (.) in the quantity field, Min field and Max field

    keyPressQTY(e) {
        const invalidChars = [".", "-", "+", "e"];
        if (invalidChars.includes(e.key)) e.preventDefault();
    };
    OnHandleExisChange = (e, type, index) => {

        let { GridData } = this.state;
        let re = SDIConstants.quantityRegEX;
        if (type == "Min") {
            if (e.target.value === '' || re.test(e.target.value)) {
                if (e.target.value != "0" && e.target.value.length <= 5 && e.target.value != "." && e.target.value.length <= 15) {
                    this.state.GridData[index].EditMinValue = e.target.value;
                }
            }
        }

        else if (type == "Max") {
            if (e.target.value === '' || re.test(e.target.value)) {
                if (e.target.value != "0" && e.target.value.length <= 5 && e.target.value != "." && e.target.value.length <= 15) {
                    this.state.GridData[index].EditMaxValue = e.target.value;
                }
            }


        }
        else if (type == "QTY") {
            if (e.target.value === '' || re.test(e.target.value)) {
                if (e.target.value != "0" && e.target.value != "." && e.target.value.length <= 5 && e.target.value.length <= 15) {
                    this.state.GridData[index].EditQuantity = e.target.value;
                }
            }

        }
        else if (type == "ReplenClass") {
            this.state.GridData[index].EditReplenClass = e.target.value;
        }

        this.setState(GridData);
    };

    ProcessReplenClick = () => {
        //let  itemsToAdd = []
        if (this.state.GridData.length > 0) {
            let itemsToAdd = [];


            this.state.GridData.forEach((value) => {

                if (value.REPLEN_STATUS == "1") {

                    itemsToAdd.push({
                        ItemID: value.INV_ITEM_ID,
                        ReplenishID: value.REPLENISH_ID,
                        ReplenStatus: value.REPLEN_STATUS,
                        TruckID: value.ISA_TRUCK_ID,
                        ReorderQuantity: value.REORDER_QTY,
                        BusinessUnit: value.BUSINESS_UNIT





                    });
                }
            })
            let BO = {

                //Region: this.state.SelectedRegion,
                //SubRegion: this.state.SelectedSubRegion,
                //TruckID: this.state.SelectedTruckId,
                //ThresHold: this.state.SelectedThreshold,
                //ReplenishStatus: this.state.SelectedReplenedClass,
                //TechName: this.state.SelectedTechName,
                //IsGridDataLoad: false,
                //IsApproveAll:false,
                UserID: CookieService.getLocalStorageValues("Session_UserID"),
                LineItems: itemsToAdd
                //Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                //Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH")

            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            MobileInventoryManagementAction.ProcessReplenClick(BO)
        }
    }
    OnStatusChangeResponse = () => {
        let GetDataResponse = JSON.parse(MobileInventoryManagementStore.OnStatusChange);
        let ErrorTable = GetDataResponse.FlagTable;

        if (ErrorTable[0].lblDBErr1 != "" && ErrorTable[0].lblDBErr1 != undefined && ErrorTable[0].lblDBErr1 != null) {


            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: ErrorTable[0].lblDBErr1
            })
            //this.GetDataClick()
            if (ErrorTable[0].lblDBErr1.toLowerCase().trim() == "updated successfully") {
                showPopUp = false
                this.GetDataClick()
                //PC_WW_1055_07, Divis Kumar R K, Call the get data function so that only the status in the filter will be present.
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue please contact SDI"
            })

        }

    }



    ApproveALLResponse = () => {
        let Response = JSON.parse(MobileInventoryManagementStore.ApproveALL);
        let GridData = Response.GridData;
        let GetDataResponse = Response.ErrorMessage;
        if (GetDataResponse[0].lblerror != "" && GetDataResponse[0].lblerror != undefined && GetDataResponse[0].lblerror != null) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: GetDataResponse[0].lblerror
            })
            if (GridData != undefined && GridData != null && GridData.length != 0) {

                GridData.forEach((value, index) => {
                    let ProcessDate = value.PROCESS_DATE;
                    if (ProcessDate != null && ProcessDate != undefined && ProcessDate != "") {
                        ProcessDate = ProcessDate.split('T')[0];
                    }
                    let LastDate = value.LAST_ISSUE;
                    if (LastDate != null && LastDate != undefined && LastDate != "") {
                        LastDate = LastDate.split('T')[0];
                    }


                    value.EditMinValue = value.REORDER_POINT;
                    value.EditMaxValue = value.QTY_MAXIMUM;
                    value.EditQuantity = value.REORDER_QTY;
                    value.EditReplenClass = value.REPLENISH_CLASS;
                    value.EditPROCESS_DATE = ProcessDate;
                    value.EditLAST_ISSUE = LastDate;


                });
                if (GetDataResponse[0].lblerror.toLowerCase().trim() == "approved successfully") {
                    showPopUp = false
                    this.setState({ SelectedReplenedClass: "" }, () => {
                        this.GetDataClick();
                    });
                }
                else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            } //PC_WW_1055_01 - PC_WW_1055_03, Divis Kumar R K, Create new keys for the state variable GridData so that the updated value can be stored.

            {/*let { GridData } = this.state;

            GridData.forEach((value, index) => {

                this.state.GridData[index].REPLEN_STATUS = "1";
            });*/}
            //this.GetDataClick()
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue please contact SDI"
            })
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }

    }
    ProcessReplenResponse = () => {
        let GetDataResponse = JSON.parse(MobileInventoryManagementStore.ProcessReplen);
        if (GetDataResponse[0].lblerror != "" && GetDataResponse[0].lblerror != undefined && GetDataResponse[0].lblerror != null) {
            //let { GridData } = this.state;
            //GridData.forEach((value, index) => {

            //    if (this.state.GridData[index].REPLEN_STATUS == "1") {
            //        this.state.GridData[index].REPLEN_STATUS = "7"
            //    }
            //});
            //this.setState({ GridData });

            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: GetDataResponse[0].lblerror
            })

        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical issue please contact SDI"
            })

        }
        showPopUp = true
        this.GetDataClick()  //PC_WW_1055_07, Divis Kumar R K, Call the get data after set stating the showPopUp as true so that pop up is displayed if no items are present.
    }
    ApproveAll = () => {
        {/*let griddataFilter = this.state.GridData.filter(item => item.REPLEN_STATUS != "1");
        if (griddataFilter.length > 0) {
          
            let itemsToAdd = [];

            griddataFilter.forEach((value) => {
                itemsToAdd.push({
                    ItemID: value.INV_ITEM_ID,
                    ReplenishID: value.REPLENISH_ID,
                    ReplenStatus: value.REPLEN_STATUS,
                    TruckID: value.ISA_TRUCK_ID,
                    ReorderQuantity: value.REORDER_QTY,
                    BusinessUnit: value.BUSINESS_UNIT
                });
            });*/}

        if (this.state.SelectedReplenedClass != '1') {
            let BO = {
                Region: this.state.SelectedRegion,
                SubRegion: this.state.SelectedSubRegion,
                TruckID: this.state.SelectedTruckId,
                ThresHold: this.state.SelectedThreshold,
                ReplenishStatus: this.state.SelectedReplenedClass,
                TechName: this.state.SelectedTechName.value,
                IsGridDataLoad: true,
                IsApproveAll: true,
                CurrentPage: this.state.pageNo,
                NeededCount: "10",
                sortBy: this.state.sort,
                UserID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                ItemID: this.state.SelectedItemID.value //PC_CPW_241_04
                //LineItems: itemsToAdd
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            MobileInventoryManagementAction.ApproveAllClick(BO)

            //let BO = {
            //    Region: this.state.SelectedRegion,
            //    SubRegion: this.state.SelectedSubRegion,
            //    TruckID: this.state.SelectedTruckId,
            //    ThresHold: this.state.SelectedThreshold,
            //    ReplenishStatus: this.state.SelectedReplenedClass,
            //    TechName: this.state.SelectedTechName,
            //    IsGridDataLoad: true,
            //    IsApproveAll: true,
            //    User_ID: CookieService.getLocalStorageValues("Session_UserID"),
            //    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            //    Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH")

            //}

        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Items are already approved"
            })

        }
    }

    ExcelButtonClick = () => {
        let BO = {
            Region: this.state.SelectedRegion,
            SubRegion: this.state.SelectedSubRegion,
            TruckID: this.state.SelectedTruckId,
            ThresHold: this.state.SelectedThreshold,
            ReplenishStatus: this.state.SelectedReplenedClass,
            TechName: this.state.SelectedTechName.value,
            IsGridDataLoad: true,
            IsApproveAll: false,
            sortBy: this.state.sort,
            EmployeeID: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            ItemID: this.state.SelectedItemID.value //PC_CPW_241_04
        }
        this.setState({ pageNo: this.state.pageNo, sort: this.state.sort, isExpand: false })
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        MobileInventoryManagementAction.ExportToExcelAction(BO)
    }

    ExportToExcelClickResponse = () => {
        //let { GridData } = this.state;

        let GridDataResponse = JSON.parse(MobileInventoryManagementStore.exceldata);
        let GridData = GridDataResponse.GridData;
        GridData.forEach((value, index) => {
            let ProcessDate = value.PROCESS_DATE;
            if (ProcessDate != null && ProcessDate != undefined && ProcessDate != "") {
                ProcessDate = ProcessDate.split('T')[0];
            }
            let LastDate = value.LAST_ISSUE;
            if (LastDate != null && LastDate != undefined && LastDate != "") {
                LastDate = LastDate.split('T')[0];
            }

            value.EditReplenClass = value.REPLENISH_CLASS;
            value.EditPROCESS_DATE = ProcessDate;
            value.EditLAST_ISSUE = LastDate;

            if (value.EditReplenClass == "AUTO") {
                value.ExporttoexcelReplenCLass = "Automatic"
            }
            else if (value.EditReplenClass == "X") {
                value.ExporttoexcelReplenCLass = "Replen off"
            }
            else if (value.EditReplenClass == "MANL") {
                value.ExporttoexcelReplenCLass = "Manual Review"
            }
            if (value.REPLEN_STATUS == "1") {
                value.ExporttoexceLREPLEN_STATUS = "Approved"
            }
            else if (value.REPLEN_STATUS == "4") {
                value.ExporttoexceLREPLEN_STATUS = "Processed"
            }
            else if (value.REPLEN_STATUS == "5") {
                value.ExporttoexceLREPLEN_STATUS = "Cancelled"
            }
            else if (value.REPLEN_STATUS == "7") {
                value.ExporttoexceLREPLEN_STATUS = "Needs Review"
            }
            let TechName = value.ISA_EMPLOYEE_NAME;
            value.ExporttoexcelISA_EMPLOYEE_NAME = TechName.replace(',', ', ');


        });
        this.setState({ GridData: GridData })
        this.bindexportToExcel()

    }
    bindexportToExcel = () => {


        const worksheet = XLSX.utils.json_to_sheet(this.state.GridData.map((val, index) => ({


            "Truck ID ": val.ISA_TRUCK_ID,
            "Tech Name": val.ExporttoexcelISA_EMPLOYEE_NAME,
            "Item ID ": val.INV_ITEM_ID,
            "Description": val.DESCR254_MIXED,
            "Cost": val.PRICE_LIST,
            "Extended Cost": val.Extended_cost,
            "Quantity": val.REORDER_QTY,

            "Manufacturer ": val.MFG_ID,
            "Vendor ": val.NAME1,
            "UOM ": val.UNIT_MEASURE_STD,
            "Package Size": val.PACK_QTY,
            "Lead Days ": val.STD_LEAD,
            "Min ": val.REORDER_POINT,
            "Max ": val.QTY_MAXIMUM,
            "On Hand ": val.QTY,
            "On Order ": val.QTY_OPEN,
            "Replen Class": val.ExporttoexcelReplenCLass,
            "MFG Item ": val.MFG_ITM_ID,
            "Vendor Item ": val.ITM_ID_VNDR,
            "Status": val.ExporttoexceLREPLEN_STATUS,
            "Date Added": val.EditPROCESS_DATE,
            "Last Issued": val.EditLAST_ISSUE





        })),
            //this.state.ForecastData.map((item, index) => ({

            //    " MONTH": item.MONTH


            //}))

        )

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'MobileInventoryManagementSystem');
        XLSX.writeFile(workbook, 'MobileInventoryMangement.xlsx');
        showPopUp = true
        this.GetDataClick()  //PC_WW_1055_07, Divis Kumar R K, Call the get data after set stating the showPopUp as true so that pop up is displayed if no items are present.
    };
    BindDataGrid = () => {
        if (this.state.GridData.length > 0) {



            return this.state.GridData.map((val, index) => {
                let desc = val.DESCR254_MIXED
                if (window.innerWidth < "1200") {
                    if (desc.length > 10) {
                        desc = desc.substring(0, 10) + "..."
                    }
                }
                let ImageUrl = "";
                if (this.state.ImageAr != "" && this.state.ImageAr != null) {
                    let ImageDet = this.state.ImageAr.filter((value, indexVal) => value.CUSTOMER_PART_NUMBER == val.INV_ITEM_ID);
                    if (typeof (ImageDet) != undefined && ImageDet.length > 0) {
                        ImageUrl = ImageDet[0].ImageUrl;
                    }
                    else {
                        ImageUrl = `/Images/noimage_new.png`;
                    }

                }
                let ThumbnailImagefile = ImageUrl.split("|")

                if (ThumbnailImagefile[0]) {
                    val.Image = ThumbnailImagefile[0].replace('\\', '/');
                    if (val.Image.toLowerCase().indexOf("http") >= 0) {
                        ImageUrl = ThumbnailImagefile[0];
                    } else {
                        ImageUrl = ThumbnailImagefile[0].lastIndexOf(`/`) >= 0 ? ThumbnailImagefile[0].substring(ThumbnailImagefile[0].lastIndexOf("/") + 1, ThumbnailImagefile[0].length) : "noimage_new.png";
                        if (ImageUrl) {
                            ImageUrl = `/Images/${ImageUrl}`;
                        }
                    }
                } else {
                    ImageUrl = `/Images/noimage_new.png`;
                }
                if (ImageUrl.includes("NoImageAvailable")) {
                    ImageUrl = `/Images/noimage_new.png`;
                }

                let ProcessDate = val.PROCESS_DATE;
                if (ProcessDate != null && ProcessDate != undefined && ProcessDate != "") {
                    ProcessDate = ProcessDate.split('T')[0];
                }
                let LastDate = val.LAST_ISSUE;
                if (LastDate != null && LastDate != undefined && LastDate != "") {
                    LastDate = LastDate.split('T')[0];
                }
                let TechName = val.ISA_EMPLOYEE_NAME;
                TechName = TechName.replace(',', ', ');

                let Month = [];
                if (this.state.ForecastData != undefined & this.state.ForecastData != "") {
                    let forcast = this.state.ForecastData.filter((value, indexVal) => value.INV_ITEM_ID == val.INV_ITEM_ID && value.truck == val.isa_truck_id);
                    Month = forcast
                }
                //if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {
                if (index < 10 && index >= 0) {

                    return (
                        <>
                            <tr className="tr-border">

                                <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)}>
                                    <span className="accordion-arrow header-arrow" id={`arrow-${index}`} />
                                </td>
                                <td >{val.ISA_TRUCK_ID}</td>
                                <td >{TechName}</td>
                                <td>{val.INV_ITEM_ID}</td>
                                <td>{desc}</td>
                                <td className="text-right">{val.PRICE_LIST}</td>
                                <td className="text-right">{val.Extended_cost}</td>
                                <td>

                                    {/*Regression bug -5519 - K. Surya - Walmart_ Mobile Inventory Management System_Able to enter the (.) in the quantity field, Min field and Max field*/}

                                    <input type="number" className="form-control" maxLength="5" value={val.EditQuantity} onChange={e => this.OnHandleExisChange(e, "QTY", index)} onKeyDown={(e) => this.keyPressQTY(e)} />

                                </td>
                                <td>
                                    <select className="form-control" value={val.REPLEN_STATUS} name="replen_status" onChange={(e) => this.OnStatusChange(e, val, index)}>

                                        <option value="1">Approved</option>
                                        <option value="4">Processed</option>
                                        <option value="5">Cancelled</option>
                                        <option value="7">Needs Review</option>
                                        {/* <option value="0">Select </option>
                                        <option value="1">Review</option>
                                        <option value="2">Approve</option>
                                        <option value="3">Cancel</option>
                                        <option value="4">Postpone Review 2 Weeks</option>
                                        <option value="5">Postpone Review 4 Weeks</option>
                                        <option value="6">Postpone Review 6 Weeks</option>
                                        <option value="7">Postpone Review 8 Weeks</option>
                                        <option value="8">Postpone Until Issue or Adjustment Occur</option>
                                        <option value="9">Autocrib</option>*/}

                                    </select>
                                </td>
                            </tr>
                            <tr className="p d-none content-row" id={`contentrow-${index}`}>
                                <td colSpan={13} className="hiddenRow">
                                    <div
                                        className="accordian-body border-top py-1 "
                                        id={`contentrow-${index}`}
                                    >
                                        <div className="row mx-0 pb-3">
                                            <div className="col-md-3 mob-inv-tab-responsive-col1 ">
                                                <div className="row">
                                                    {ImageUrl != "" ? <div className="col-md-12">
                                                        <img src={ImageUrl} alt="Image" className="mob-inv-Image-size" />
                                                    </div> : <div className="col-md-12">
                                                            <img src="/Images/noimage_new.png" className="mob-inv-Image-size" alt="No_Image" />
                                                        </div>}

                                                    <div className="col-md-4 ">
                                                        <label className="float-left form-label catalog-label">
                                                            Date Added :
                      </label>
                                                    </div>
                                                    <div className="col-md-8 ">
                                                        <label className="form-label label-value ">
                                                            {ProcessDate}
                                                        </label>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="float-left form-label catalog-label">
                                                            Last Issued :
                      </label>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <label className="form-label label-value ">
                                                            {LastDate}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-5 mob-inv-tab-responsive-col2">
                                                <div className="row">
                                                    <div className="col-lg-3 col-md-4">
                                                        <label className="float-left form-label catalog-label">
                                                            Manufacturer :
                      </label>
                                                    </div>
                                                    <div className="col-lg-9 col-md-8">
                                                        <label className="form-label label-value ">
                                                            {val.MFG_ID}
                                                        </label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="float-left form-label catalog-label">
                                                            Vendor :
                      </label>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <label className="form-label label-value ">
                                                            {val.NAME1}
                                                        </label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="float-left form-label catalog-label">
                                                            UOM :
                      </label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="form-label label-value ">{val.UNIT_MEASURE_STD}</label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="float-left form-label catalog-label">
                                                            Package Size :
                      </label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="form-label label-value ">{val.PACK_QTY}</label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="float-left form-label catalog-label">
                                                            Lead Days :
                      </label>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <label className="form-label label-value ">{val.STD_LEAD}</label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="float-left form-label catalog-label">
                                                            Min <span className="info-container ml-2">
                                                                <img style={{ width: "15px" }} src="Images/info-icon.png" />
                                                                <span className="Grid-info-icon text-left sdi-fede-tooltippickup ">Quantity should be 1 or greater.</span>
                                                            </span> :
                                                            
                      </label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <input
                                                            maxLength="5"
                                                            type="number"
                                                            className="form-control "
                                                            placeholder="Enter Min"
                                                            value={val.EditMinValue}
                                                            onChange={(e) => this.OnHandleExisChange(e, "Min", index)}
                                                            onKeyDown={(e) => this.keyPressQTY(e)}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="float-left form-label catalog-label">
                                                            Max <span className="info-container ml-2">
                                                                <img style={{width:"15px"}} src="Images/info-icon.png" />
                                                                <span className="Grid-info-icon text-left sdi-fede-tooltippickup ">Qty to be ordered = Max Qty - Qty Available</span>
                                                            </span> :
                                                            
                      </label>
                                                    </div>
                                                    <div className="col-md-3">

                                                        <input
                                                            type="number"

                                                            defaultValue={6}
                                                            className="form-control"
                                                            placeholder="Enter Max"
                                                            maxLength="5"
                                                            value={val.EditMaxValue}
                                                            onChange={(e) => this.OnHandleExisChange(e, "Max", index)}
                                                            onKeyDown={(e) => this.keyPressQTY(e)}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="float-left form-label catalog-label">
                                                            On Hand :
                      </label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="form-label label-value ">{val.QTY}</label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="float-left form-label catalog-label">
                                                            On Order :
                      </label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="form-label label-value ">{val.QTY_OPEN}</label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="float-left form-label catalog-label">
                                                            Replen Class :
                      </label>
                                                    </div>
                                                    <div className="col-md-9">

                                                        <select className="form-control" name="replen_type" value={val.EditReplenClass} onChange={(e) => this.OnHandleExisChange(e, "ReplenClass", index)}>
                                                            {/*<option value="">Select </option>*/}
                                                            <option value="MANL">Replen On</option>
                                                            {/*<option value="AUTO">Automatic</option>*/}
                                                            <option value="X">Replen Off</option>

                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 mob-inv-tab-responsive-col3">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <label className="float-left form-label catalog-label">
                                                            MFG Item :
                      </label>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <label className="form-label label-value">
                                                            {val.MFG_ITM_ID}
                                                        </label>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="float-left form-label catalog-label">
                                                            Vendor Item :
                      </label>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <label className="form-label label-value">
                                                            {val.ITM_ID_VNDR}
                                                        </label>
                                                    </div>
                                                    {Month.length > 0 ?

                                                        <>
                                                            <div className="col-md-6">
                                                                <label className="float-left form-label catalog-label mob-tbl-header">
                                                                    Quantity Usage
                      </label>
                                                            </div>



                                                            <div className="col-lg-12 mt-2">
                                                                <div className="table-responsive tabel-scroll-mob-inv">
                                                                    <table className="table ZEUS_Grid FOM-grid mobileresponsive-grid">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Month</th>
                                                                                <th className="text-right">Usage</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {this.Bindforcast(Month)}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div></> : null}
                                                </div>
                                            </div>
                                            <div className="col-md-12 my-3 float-left p-0">
                                                <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={(e) => this.SaveItemClick(e, val, index)}>
                                                    Save
                  </button>
                                                <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-3" onClick={(e) => this.cancelClick("grid", index)}>
                                                    Cancel
                  </button>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                        </>);
                }
            })
        }
    }
    render() {
        return (
            <> <div className="container-fluid content-section content-margin" style={{ marginTop: "174px" }}>
                <div className="">
                    {/* Title - Starts here */}
                    <>
                        <div className="col-md-12 page-heading mb-3">
                            <h5 className="page-title">Mobile Inventory Management System</h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-Fav" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-Fav">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                    </>


                    {/* Title - Ends here */}
                    <div className="col-md-12 float-left border-bottom mt-4">
                        <div className="row mob-inv-respnsive-dropdown ">
                            <div className="col-md-4 col-lg-3 mb-3">
                                <label className="catalog-label w-100"><Trans>Region</Trans></label>

                                <select className="form-control" name="region" value={this.state.SelectedRegion} onChange={(e) => this.dropDownhandlechange(e, "Region")}>
                                    <option value="">Select All</option>
                                    {this.BindRegion()}
                                </select>



                            </div>
                            <div className="col-md-4 col-lg-3 mb-3">
                                <label className="catalog-label  w-100"><Trans>Subregion</Trans></label>
                                <select className="form-control"
                                    name="subregion"
                                    onChange={(e) => this.dropDownhandlechange(e, "SubRegion")}
                                    value={this.state.SubRegionSelected}>

                                    <option value="">Select All</option>
                                    {this.BindSubRegion()}
                                </select>

                            </div>
                            <div className="col-md-4 col-lg-3 mb-3">
                                <label className="catalog-label w-100"><Trans>Truck ID</Trans></label>

                                <select className="form-control"
                                    name="TruckIDDD"
                                    onChange={(e) => this.dropDownhandlechange(e, "TruckID")}
                                    value={this.state.SelectedTruckId}>

                                    <option value="">Select All</option>
                                    {this.BindTruckid()}
                                </select>

                            </div>
                            <div className="col-md-4 col-lg-3 mb-3">

                                <label className="catalog-label w-100"><Trans>Threshold</Trans></label>
                                <span style={{ "fontSize": "14px" }}>
                                    <select className="form-control" name="Threshold" value={this.state.SelectedThreshold} onChange={(e) => this.dropDownhandlechange(e, "Threshold")}>
                                        <option value="">Select </option>
                                        <option value="0">Below Min Level </option>
                                        <option value="1">Back Order Risk</option>
                                    </select>

                                </span>
                            </div>



                            <div className="col-md-4 col-lg-3 mb-3">

                                <label className="catalog-label w-100">Replenishment status</label>
                                <select className="form-control" name="ReplenishStatus" value={this.state.SelectedReplenedClass} onChange={(e) => this.dropDownhandlechange(e, "ReplenishStatus")}>
                                    <option value="">Select </option>
                                    <option value="1">Approved</option>
                                    <option value="4">Processed</option>
                                    <option value="5">Cancelled</option>
                                    <option value="7">Needs Review</option>
                                    {/* <option value="1">Review</option>
                                    <option value="2">Approve</option>
                                    <option value="3">Cancel</option>
                                    <option value="4">Postpone Review 2 Weeks</option>
                                    <option value="5">Postpone Review 4 Weeks</option>
                                    <option value="6">Postpone Review 6 Weeks</option>
                                    <option value="7">Postpone Review 8 Weeks</option>
                                    <option value="8">Postpone Until Issue or Adjustment Occur</option>
                                    <option value="9">Autocrib</option>*/}
                                </select>


                            </div>
                            <div className="col-md-4 col-lg-3 mb-3">
                                <label className="catalog-label w-100"><Trans>Tech name</Trans></label>
                                <Select
                                    className="DropDown-Font-Size"
                                    options={this.state.TechNameDD}
                                    name="TruckIDDD"
                                    id="TechNameDD"
                                    onChange={(e) => this.dropDownhandlechange(e, "TechName")}
                                    value={this.state.SelectedTechName} />


                                {/* <select className="form-control"
                                    name="TruckIDDD"
                                    id="TechNameDD"
                                onChange={(e) => this.dropDownhandlechange(e, "TechName")}
                                value={this.state.SelectedTechName}>
                                <option value="">Select</option>

                                {this.BindTechName()}
                            </select>*/}

                            </div>
                            <div className="col-md-4 col-lg-3 mb-3">
                                <label className="catalog-label w-100"><Trans>Item ID</Trans></label>
                                <Select
                                    className="DropDown-Font-Size"
                                    options={this.state.ItemIDData}
                                    name="ItemIDData"
                                    id="ItemIDData"
                                    onChange={(e) => this.dropDownhandlechange(e, "ItemID")}
                                    value={this.state.SelectedItemID} />

                            </div>
                            <div className="col-md-12 my-3 float-left p-0">
                                <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4" onClick={() => {
                                    showPopUp = true;
                                    this.GetDataClick();
                                }}>
                                    Get Data
    </button>
                                <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-4 mr-3" onClick={(e) => this.cancelClick("pageload", 1)}>
                                    Clear
    </button>
                            </div>


                        </div>

                    </div>

                    {/* Filter Component - Starts here */}






                    {this.state.GridData.length > 0 ?
                        <div className="row mt-4">
                            <div className="col-md-12 my-3">
                                <div className="row justify-content-between m-0">
                                    <div className="text-left mb-3">

                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4 mr-3" onClick={this.expandAll} >{!this.state.isExpand ? `Expand All` : `Collapse All`}</button>



                                    </div>
                                    <div className="text-right">
                                        {/* Title  
                                <span className="fav-item-title">
                                    <span className="info-container mr-3">
                                        <img className="info-searchpage" src="Images/info-icon.png" />
                                            <span className="Grid-info-icon text-left" style={{ "right": "272px" }}>
                                            Replen can be processed only if the order qty is greater than zero
                                            and status as "Approve" and also the line must have been saved before
                                            processing replen
          </span>
                                    </span>
                                        </span>*/}
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4 mr-3" onClick={this.ExcelButtonClick}><Trans>Export to Excel</Trans></button>
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4 mr-3" onClick={this.ApproveAll} >Approve All</button>

                                        {/*   <button className="btn btn-primary custom-btn-primary primary-btn float-right px-4 mr-3" onClick={() => this.ProcessReplenClick()}  >
                                        Process Replen
      </button>*/}



                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div className="table-responsive">
                                    <table className="table ZEUS_Grid FOM-grid mobileresponsive-grid">
                                        <thead>
                                            <tr>
                                                <th />
                                                <th className="position-sort-icon">Truck ID</th>
                                                <th className="position-sort-icon">Tech Name</th>
                                                <th className="position-sort-icon">
                                                    Item ID
            <span className="sort-up ml-1">
                                                        <img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "ItemID")} />
                                                    </span>
                                                    <span className="sort-down ml-1">
                                                        <img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "ItemID")} />
                                                    </span>
                                                </th>
                                                <th className="position-sort-icon">Description</th>
                                                <th className="position-sort-icon text-right">Cost</th>
                                                <th className="position-sort-icon text-right">Extended Cost</th>
                                                <th className="position-sort-icon">Quantity</th>
                                                <th className="position-sort-icon">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.BindDataGrid()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div> : null}
                    <div className="col-md-12">

                        {this.state.GridData.length > 0 ?
                            <div className="col-md-12 mb-3 p-0">
                                <span className="total-records mb-2">
                                    <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.totalRecords}</span>
                                </span>
                                {this.state.GridData.length > 0 ? <ReactPaginate
                                    previousLabel={<span className="right-pagination-arrow" />}
                                    nextLabel={<span className="left-pagination-arrow" />}
                                    previousClassName={'page-item'}
                                    nextClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextLinkClassName={'page-link'}
                                    disabledClassName={'disabled'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={2}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={'custom-pagination pagination float-right'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                    hrefBuilder={() => '#'}
                                    forcePage={this.state.pageNo - 1}
                                /> : null}

                            </div> : null}
                    </div>
                </div>

                <div className="modal" id="reasonPopUp" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Reason for choosing replenishment off</Trans></h4>
                                <button type="button" className="btn close-btn" onClick={() => this.hidePopUp()}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            <div className="modal-body" >
                                <div className="row">
                                    <div className="col-md-12 float-left">
                                        <div className="col-md-12 col-lg-12 mb-3 float-left p-0">
                                            <label className="float-left"><Trans>Reason</Trans></label>

                                            <select className="form-control float-left" value={this.state.selectedOption} onChange={(e) => this.onChangeReasonPopup(e)}>
                                                <option value="">Select an option</option>
                                                {this.bindReasons()}
                                            </select>


                                        </div>
                                        <div className="center"><span className="error_message" hidden={this.state.reasonError}>Please select an option to submit the reason</span></div>
                                    </div>

                                </div>
                                <div className="col-md-12 text-center mb-2 mt-2">
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 mt-3" onClick={() => this.insertReason()}><Trans>Submit</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            </>

        );
    }

}
export default withTranslation()(MobileInventoryManagementComponent);